@if (modalMode) {
  <div class="modal-header">
    <h5 class="modal-title">Synthèse des volumes - {{ raisonSociale }}</h5>

    <div class="pointer ms-auto" data-dismiss="modal" aria-label="Close">
      <fa-icon
        icon="times"
        (click)="activeModal?.dismiss()"
        (keydown.enter)="activeModal?.dismiss()">
      </fa-icon>
    </div>
  </div>
}

<div
  [class.synthese-modal-content]="modalMode"
  [class.content]="!modalMode">

  <div
    [class.synthese-modal-body]="modalMode"
    [class.content-panel-overflow]="!modalMode">

        <form [formGroup]="formGroup" #form="ngForm">
            <p-floatlabel variant="on">
                <input
                    pInputText
                    id="campagne"
                    formControlName="campagne"
                    maxlength="4"
                    [ngClass]="{'is-invalid': campagne.dirty && campagne.invalid}"
                    class="campagne-input" />
                <label for="campagne" translate>page.declarations.synthese.annee</label>
            </p-floatlabel>
        </form>

        <!-- Produits AOC -->
        @if (useAOC && synthesesVolumesAOC) {
            @if (synthesesVolumesAOC.length > 0) {
                <div class="d-flex justify-content-end mb-2 me-2">
                    <button class="btn btn-outline-primary d-flex align-items-center" (click)="openColumnModal()">
                        <fa-icon icon="columns"></fa-icon>
                        <span class="px-2">Colonnes</span>
                        <span class="badge bg-primary text-white ms-2">{{ getVisibleColumnCount() }} / {{ columnsAOC.length }}</span>
                    </button>
                </div>
            }

            @if (synthesesVolumesAOC.length) {
                <p-table [value]="synthesesVolumesAOC" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            @for (col of columnsAOC; track $index) {
                                @if (col.visible) {
                                    <th scope="col" [ngClass]="{'text-start': col.field === 'produit', 'text-center': col.field !== 'produit'}">
                                        <div style="white-space: pre-line" translate>{{ col.label }}</div>
                                    </th>
                                }
                            }
                            @if(!readOnly){
                            <th scope="col"></th>
                            }
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-synthese>
                        <tr>
                            @for (col of columnsAOC; track $index) {
                                @if (col.visible) {
                                    <td [ngClass]="{'text-start': col.field === 'produit', 'text-end': col.field !== 'produit'}">
                                        {{ getCellValue(col.field, synthese) }}
                                    </td>
                                }
                            }
                            
                            @if(!readOnly){
                            <td class="d-flex align-items-center justify-content-end">
                                <p-button
                                    icon="pi pi-arrow-right-arrow-left"
                                    [pTooltip]="'page.declarations.synthese.changementProduit' | translate"
                                    tooltipPosition="left"
                                    class="buttonIcon"
                                    (click)="changementDenomination(synthese)"
                                    (keydown.enter)="changementDenomination(synthese)"
                                    [outlined]="true">
                                </p-button>
                                <p-button
                                    *hasHabilitation="'VIN_PROD_CONDITIONNEMENT';cahier synthese.produit?.idCahier;elseDisable"
                                    [pTooltip]="'page.declarations.synthese.saisirConditionnement' | translate"
                                    tooltipPosition="left"
                                    class="buttonIcon"
                                    (click)="saisirConditionnement(synthese)"
                                    (keydown.enter)="saisirConditionnement(synthese)"
                                    [outlined]="true">
                                    <fa-icon icon="wine-bottle"></fa-icon>
                                </p-button>
                                <p-button
                                    *hasHabilitation="'VIN_PROD_CONDITIONNEMENT || VIN_PROD_VIGNIFICATION || VIN_PROD_ELABORATION';cahier synthese.produit?.idCahier;elseDisable"
                                    icon="pi pi-euro"
                                    [pTooltip]="'page.declarations.synthese.saisirTransaction' | translate"
                                    tooltipPosition="left"
                                    class="buttonIcon"
                                    (click)="transaction(TypeCahierCode.AOC, synthese.produit)"
                                    (keydown.enter)="transaction(TypeCahierCode.AOC, synthese.produit)"
                                    [outlined]="true">
                                </p-button>
                                @if (synthese.produit?.vinBase) {
                                    <p-button
                                        *hasHabilitation="'VIN_PROD_ELABORATION';cahier synthese.produit?.idCahier;elseDisable"
                                        [pTooltip]="'page.declarations.synthese.saisirTirage' | translate"
                                        tooltipPosition="left"
                                        class="buttonIcon"
                                        (click)="tirage(TypeCahierCode.AOC, synthese)"
                                        (keydown.enter)="tirage(TypeCahierCode.AOC, synthese)"
                                        [outlined]="true">
                                        <fa-icon icon="wine-bottle"></fa-icon>
                                    </p-button>
                                }
                            </td>
                            }
                        </tr>
                    </ng-template>
                </p-table>
                 
            } @else {
                <p-message severity="info" icon="pi pi-exclamation-circle" class="w-75">
                    {{ 'page.declarations.synthese.table.aucunProduit' | translate }}
                </p-message>
            }
            
            @if(!readOnly){
            <div class="pt-3 ps-2">
                <p-button
                    label="{{ 'page.declarations.synthese.autre-produit' | translate }}"
                    icon="pi pi-arrow-right-arrow-left"
                    type="button"
                    (click)="changementDenominationHorsBacchus(TypeCahierCode.AOC)"
                    (keydown.enter)="changementDenominationHorsBacchus(TypeCahierCode.AOC)">
                </p-button>
            </div>
          }
        }

        <!-- Produits IGP -->
        @if (useIGP && synthesesVolumesIGP) {
            @if (synthesesVolumesIGP.length) {
                <p-table
                    #dt
                    [value]="synthesesVolumesIGP"
                    [scrollable]="true"
                    scrollHeight="calc(100vh - 250px)">
                    <ng-template pTemplate="header">
                        <tr>
                            @for (col of columnsIGP; track $index) {
                                <th scope="col" [ngClass]="{'text-start': col.field === 'produit', 'text-center': col.field !== 'produit'}">
                                    <div style="white-space: pre-line" translate>{{ col.label }}</div>
                                </th>
                            }
                             @if(!readOnly){
                            <th scope="col"></th>
                             }
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-synthese>
                        <tr>
                            @for (col of columnsIGP; track $index) {
                                <td [ngClass]="{
                                    'text-start': col.field === 'produit',
                                    'text-end': col.field !== 'produit',
                                    'est-negatif': col.field === 'resteARevendiquer' && synthese.resteARevendiquer < 0
                                }">
                                    {{ getCellValueIGP(col.field, synthese) }}
                                </td>
                            } 
                            @if(!readOnly){
                            <td class="d-flex align-items-center justify-content-end">
                                @if (SessionContext.get('utilisateurType') !== UtilisateurTypeCode.OPERATEUR) {
                                    <p-button
                                        icon="pi pi-pencil"
                                        aria-label="Modifier DR"
                                        [pTooltip]="'page.declarations.synthese.modifierDr' | translate"
                                        tooltipPosition="left"
                                        class="buttonIcon"
                                        (click)="modifierDr(synthese)"
                                        (keydown.enter)="modifierDr(synthese)"
                                        [outlined]="true">
                                    </p-button>
                                }
                                <p-button
                                    icon="pi pi-arrow-right-arrow-left"
                                    [pTooltip]="'page.declarations.synthese.changementProduit' | translate"
                                    tooltipPosition="left"
                                    class="buttonIcon"
                                    (click)="changementDenominationIgp(synthese)"
                                    (keydown.enter)="changementDenominationIgp(synthese)"
                                    [outlined]="true">
                                </p-button>
                                <p-button
                                    [pTooltip]="'page.declarations.synthese.saisirConditionnement' | translate"
                                    tooltipPosition="left"
                                    class="buttonIcon"
                                    (click)="saisirConditionnementIgp(synthese)"
                                    (keydown.enter)="saisirConditionnementIgp(synthese)"
                                    [outlined]="true"
                                    [hidden]="true">
                                    <fa-icon icon="wine-bottle"></fa-icon>
                                </p-button>
                                <p-button
                                    *hasHabilitation="'VIN_PROD_CONDITIONNEMENT || VIN_PROD_VIGNIFICATION';cahier synthese.produit?.idCahier;elseDisable"
                                    icon="pi pi-euro"
                                    [pTooltip]="'page.declarations.synthese.saisirTransaction' | translate"
                                    tooltipPosition="left"
                                    class="buttonIcon"
                                    (click)="transaction(TypeCahierCode.IGP, synthese.produit)"
                                    (keydown.enter)="transaction(TypeCahierCode.IGP, synthese.produit)"
                                    [outlined]="true"
                                    [hidden]="true">
                                </p-button>
                            </td>
                            }
                        </tr>
                    </ng-template>
                </p-table>
              
            } @else {
                <p-message severity="info" icon="pi pi-exclamation-circle">
                    {{ 'page.declarations.synthese.table.aucunProduit' | translate }}
                </p-message>
            }
                @if(!readOnly){
                <div class="d-flex gap-3 pt-3">
                    <p-button
                        label="{{ 'page.declarations.synthese.saisirRevendication' | translate }}"
                        icon="pi pi-sign-in"
                        type="button"
                        (click)="SaisirRevendicationIgp()"
                        (keydown.enter)="SaisirRevendicationIgp()">
                    </p-button>
                    <p-button
                        label="{{ 'page.declarations.synthese.autre-produit' | translate }}"
                        icon="pi pi-arrow-right-arrow-left"
                        type="button"
                        (click)="changementDenominationHorsBacchus(TypeCahierCode.IGP)"
                        (keydown.enter)="changementDenominationHorsBacchus(TypeCahierCode.IGP)">
                    </p-button>
                </div>
                }
              }        
    </div>
</div>

<app-saisir-revendication
    [(visible)]="saisieDialogVisible"
    [campagne]="campagne.value"
    [lotRevendications]="saisieDialogLot"
    [indexModification]="saisieDialogIndex"
    (terminer)="onSaisieRevendicationTerminer($event)">
</app-saisir-revendication>

<app-synthese-saisie-revendication
    [(visible)]="syntheseDialogVisible"
    [lotRevendications]="syntheseLot"
    [creerRevendication]="creerRevendicationSynthese"
    (fermerModale)="onSyntheseRevendicationClose($event)">
</app-synthese-saisie-revendication>

<app-column-visibility-modal
    [visible]="showColumnVisibilityModal()"
    (visibleChange)="onColumnModalVisibleChange($event)"
    [columns]="useIGP ? columnsIGP : columnsAOC"
    [columnsMax]="8"
    [STORAGE_KEY]="STORAGE_KEY"
    (columnsChange)="onColumnsChange($event)">
</app-column-visibility-modal>
